
export { LottieIcon } from "./src/components/lottie-icon"